import React,{Component} from "react";
import { Row, Col, Card, CardHeader, CardBody, Button,
  Form,
  FormInput,
  FormGroup,
 
   ListGroup,
  ListGroupItem,
   
   } from "shards-react";
   
import firebase from '../firebase';
import { toast } from 'react-toastify';
import { AtomSpinner } from 'react-epic-spinners';

export default class AddSubject extends Component{
  constructor(props) {
    super(props);
  
    this.state = {loading:false,subjectcode:null,subjectname:null};

    this.add_subject = this.add_subject.bind(this);
  }

  componentWillUnmount(){
    this.props.refresh();
  }

  add_subject = (evt)=>{
      var that = this;
      evt.preventDefault();

      this.setState({loading:true});
      var data ={
                subjectname:this.state.subjectname,
                subjectcode:this.state.subjectcode
              };
      console.log(data);
       var func_ref = firebase.functions().httpsCallable('AddSubject');                       
                       
       func_ref(data).then(function(result) {
                  // Read result of the Cloud Function.
                  var data = result.data;
                  console.log(data);
                  if(data.status==="success"){
                        console.log("Document succesfully added!");
                        toast('Subject  Added Successfully !', {containerId: 'A'});

                   }
                  else{
                        toast(data.error.message, {containerId: 'A'});
                        console.log(data.error.message);
                  }
                  that.setState({loading:false});

        }).catch(function(error) {
                  // Getting the Error details.
                  //var code = error.code;
                  //var message = error.message;
                  //var details = error.details;
                  // ...
                  console.log(error);
                  that.setState({loading:false});
                  toast("Unable to add subject", {containerId: 'A'});
        });

      
  }


  render(){
    return(

  <Card small className="h-100" style={{margin:"5%"}}>
        <CardHeader className="border-bottom">
          <h6 className="m-0">Add New Subject</h6>
        </CardHeader>
        <CardBody className="pt-0">
          <ListGroup flush>
    <ListGroupItem className="p-3">
      <Row>
        <Col>
          
          <Form onSubmit={this.add_subject}>        
           

            <FormGroup>
              <label htmlFor="feInputClassname" style={{color:'blue'}}>Subject Name</label>
              <FormInput id="feInputAddress" 
                         placeholder="Subject Name" 
                         onChange={(evt)=>{this.setState({subjectname:evt.target.value})}}
                         />
            </FormGroup>

            <FormGroup>
              <label htmlFor="feInputclasscode" style={{color:'blue'}}>Subject Code</label>
              <FormInput
                id="feInputclasscode"
                placeholder="Subject Code"
                onChange={(evt)=>{this.setState({subjectcode:evt.target.value})}}
              />
            </FormGroup>

            {
              !this.state.loading && 
            <div>
              <Button type="submit">Add new Subject</Button>
              <Button type="button" style={{marginLeft: '5%'}} theme="danger" onClick={()=>this.props.cancel()}>Cancel</Button>
            </div>
            }
            { this.state.loading && 
              <AtomSpinner color="blue" />
            }
          </Form>
        </Col>
      </Row>
    </ListGroupItem>
  </ListGroup>
        </CardBody>
      </Card>
        
    )
  }
}